var _path, _path2, _rect, _rect2, _rect3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFileIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 64,
    height: 80,
    viewBox: "0 0 64 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 2H40L56 18V78H8V2Z",
    fill: "white",
    stroke: "#E5E7EB",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M40 2L56 18H44C41.7909 18 40 16.2091 40 14V2Z",
    fill: "#F1F1F1",
    stroke: "#E5E7EB",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 28,
    width: 32,
    height: 2.5,
    rx: 1.25,
    fill: "#E5E7EB"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 36,
    width: 24,
    height: 2.5,
    rx: 1.25,
    fill: "#E5E7EB"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 16,
    y: 70,
    width: 20,
    height: 2.5,
    rx: 1.25,
    fill: "#E5E7EB"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFileIcon);
export default __webpack_public_path__ + "static/media/fileIcon.f9f93b287238db0b801412a04d272c60.svg";
export { ForwardRef as ReactComponent };